import { combineReducers } from 'redux';
import { topicReducer } from 'redux/reducers/topicReducer';
import { informationRecucer } from 'redux/reducers/informationRecucer';
import { TypedUseSelectorHook, useSelector } from 'react-redux';

export const rootReducer = combineReducers({
  topic: topicReducer,
  indormation: informationRecucer,
});


export type ApplicationState = ReturnType<typeof rootReducer>

export const useTypedSelector: TypedUseSelectorHook<ApplicationState> = useSelector;